<template>
  <ui-route-aware-modal-container
    :id="HIRE_TEAM_CREATE_MODAL_ID"
    :size="UI.SIZE.SMALL"
    :fallback-route="parentRoute"
    focus="input[name='label']"
    no-header
    no-footer
  >
    <template #default="{ hideModalAndGoToRoute }">
      <details-form
        v-bind="{
          callback: data => createCallback(data, hideModalAndGoToRoute),
          isPending,
        }"
        :default-data="{}"
      />
    </template>
  </ui-route-aware-modal-container>
</template>

<script lang="ts">
import DetailsForm from '~/components/hamac/team/DetailsFormCreate.vue'
import Console from '~/utils/lib/core/console'
import { join, noop, toString } from '~/utils/lib/core/prelude'
import { getDetailsRoute, getListRoute } from '~/stores/hamac/team'
import { MENU_ITEM, NAVIGATION_SCOPE } from '~/utils/lib/layout/types'
import { useToastBuilder } from '~/composables/layout/toast'
import { useCompanyRequiredNavigationContext } from '~/composables/layout/navigation'
import { useStore_hamac_team_details } from '~/stores/hamac/team/details'
import { EVENTS } from '~/stores/hamac/team/list'

const console = new Console('component:team-create')

const HIRE_TEAM_CREATE_MODAL_ID = `hamac-team-create-modal-id`

export default defineNuxtComponent({
  components: { DetailsForm },
  setup() {
    definePageMeta({
      navigationScope: NAVIGATION_SCOPE.COMPANY_REQUIRED,
      menuItem: MENU_ITEM.EMBAUCHE,
    })
    const navigationContext = useCompanyRequiredNavigationContext()

    useHead({
      title: join(' ', [
        `Équipe → ajout`,
        `— ${navigationContext.fromCompanyLevel().company.raison_sociale}`,
      ]),
    })

    const triggeredParentListRefresh
      = inject(EVENTS.ON_TEAM_LIST_REFRESH_NEEDED, noop)

    const ToastBuilder = useToastBuilder()

    const store_team_details = useStore_hamac_team_details()

    const parentRoute = getListRoute(
      navigationContext.fromCompanyLevel().structure.id,
      navigationContext.fromCompanyLevel().company.code_societe
    )

    return {
      ...navigationContext,
      ToastBuilder,
      parentRoute,
      store_team_details,
      triggeredParentListRefresh,
    }
  },
  data() {
    return {
      HIRE_TEAM_CREATE_MODAL_ID,
      isPending: false
    }
  },
  methods: {
    createCallback(data, hideModalAndGoToRoute) {
      const opts = {
        data,
        uuidData: this.fromCompanyLevel().structure.uuidData,
        code_societe: this.fromCompanyLevel().company.code_societe,
      }

      this.isPending = true

      return this.store_team_details.create(opts)
        .then(({ uuid_hamac_equipe }) => {
          const {
            structure: { id },
            company: { code_societe }
          } = this.fromCompanyLevel()
          const url = getDetailsRoute(id, code_societe, uuid_hamac_equipe)

          this.triggeredParentListRefresh()

          hideModalAndGoToRoute(url, () => {
            this.ToastBuilder
              .success()
              .class('hire-team-create-toast')
              .title(`Équipe ajoutée !`)
              .show()
          })
        })
        .catch(err => {
          this.isPending = false

          console.warn('createCallback', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Ajout équipe`)
            .show()
        })
    }
  }
})
</script>
